function subPageCardsFn() {
	const subPageCardBlocks = document.querySelectorAll('.block.subPageCards');

	subPageCardBlocks.forEach(function(subPageCardBlock) {
		const subpagecards = subPageCardBlock.querySelectorAll('.subpage-card');

		subpagecards.forEach(card =>
			card.addEventListener('mouseover', () => card.querySelector('h3').classList.add('active'))
		);
		subpagecards.forEach(card =>
			card.addEventListener('mouseout', () => card.querySelector('h3').classList.remove('active'))
		);

		const subpageSectionList = subPageCardBlock.querySelector('.page-section-list');

		if (subpageSectionList) {
			const subpagesectionbuttons = subpageSectionList.querySelectorAll('.section-title .button');
			subpagesectionbuttons.forEach(function(button) {
				button.addEventListener('click', function(e) {
					e.preventDefault();
					const relatedbuttons = subpageSectionList.querySelectorAll('.section-title .button');
					const sectionwrapper = subpageSectionList.nextElementSibling;
					const allsections = sectionwrapper.querySelectorAll('.page-cards');
					const seeAllButtonsWrapper = subPageCardBlock.querySelector('.page-cards-section-button');

					const buttonindex = button.getAttribute('data-section-index');
					const previoussection = sectionwrapper.querySelector('.page-cards.active');
					const newsection = button.getAttribute('data-section');

					const previousactivebutton = subpageSectionList.querySelector('.button.active');
					const previousactivebuttonindex = previousactivebutton.getAttribute('data-section-index');

					if (!button.classList.contains('active')) {
						relatedbuttons.forEach(function(rbutton) {
							rbutton.classList.remove('active');
						});
						button.classList.add('active');

						if (buttonindex > previousactivebuttonindex) {
							sectionwrapper.classList.remove('animate-right');
							sectionwrapper.classList.add('animate-left');
							if (seeAllButtonsWrapper) {
								seeAllButtonsWrapper.classList.remove('animate-right');
								seeAllButtonsWrapper.classList.add('animate-left');
							}
						} else {
							sectionwrapper.classList.remove('animate-left');
							sectionwrapper.classList.add('animate-right');
							if (seeAllButtonsWrapper) {
								seeAllButtonsWrapper.classList.remove('animate-left');
								seeAllButtonsWrapper.classList.add('animate-right');
							}
						}

						if (seeAllButtonsWrapper) {
							const seeAllButtons = seeAllButtonsWrapper.querySelectorAll('.button');
							seeAllButtons.forEach(function(seeAllButton) {
								seeAllButton.classList.remove('active');
							});
							const activeSeeAllButton = seeAllButtonsWrapper.querySelector('.button[data-section="' + newsection + '"]');
							if (activeSeeAllButton) {
								activeSeeAllButton.classList.add('active');
							}
						}

						previoussection.classList.add('out');
						setTimeout(function(){
							previoussection.classList.remove('out');
						}, 300);
						allsections.forEach(function(asection) {
							asection.classList.remove('active');
						});

						setTimeout(function(){
							sectionwrapper.querySelector('.' + newsection).classList.add('active');
						}, 300);
					};
				});
			});
		}
	});
}

const subPageCards = {
	init: function() {
		subPageCardsFn();
	},
};

export default subPageCards;
